<template>
    <div>
        <hp5-spacing-vertical xs="xs" sm="xs" md="xs" lg="xs"></hp5-spacing-vertical>
        <hp5-button-decorator>
            <button v-on:click="onFilterButtonClick">Apply Filters</button>
        </hp5-button-decorator>
        <hp5-spacing-vertical xs="xxs" sm="xxs" md="xxs" lg="xxs"></hp5-spacing-vertical>
        <hp5-button-decorator type="secondary">
        <button v-on:click="onClearFilterButtonClick">Clear Filters</button>
            <div aria-live="polite" v-if="clearText" style="color: transparent;">{{ clearText }}</div>
        </hp5-button-decorator>
    </div>      
</template>

<script setup>

    /**
     * This Component lays out and controls the fitler controls - buttons etc. and their function.
     */

    const model = useFCPModel()
    const { filterContext, profile, plan } = model
    const { filter } = useSearch(model)

    const clearText = ref('')

    async function onFilterButtonClick() {
        const digitalData = window.digitalData || []
        const event = 'FilterSearch_submit'
        digitalData.push({
            eventData: {
            appliedFilters: filterContext.value,
            networkName: model.plan.value.name,
            },
            event: event,
        })
        await filter()
    }

    function clearFilters() {
      //If the profile is not authenticated and has an asofDate, set it on the context if the asOfDate has not already been supplied on the URL.
      filterContext.value.asOfDate = !profile.value.isAuthenticated && profile.value.asOfDate ? profile.value.asOfDate : ''
      filterContext.value.languageId = ''
      filterContext.value.language = ''
      filterContext.value.gender = ''
      filterContext.value.distance = 20
      filterContext.value.careNetworkId =
        plan.value.primaryCareClinic && plan.value.primaryCareClinic.careNetwork ? plan.value.primaryCareClinic.careNetwork.id : ''
      filterContext.value.hLabel = ''
      filterContext.value.hCode = ''
      filterContext.value.code = ''
      filterContext.value.cc = []
      filterContext.value.pcOnly = false
      filterContext.value.tier = ''
      filterContext.value.networkIndex = '0'
      filterContext.value.races = []
      filterContext.value.ethnicities = []
      filterContext.value.origins = []
      filterContext.value.acceptingNewPatients = ''
      // need to re-search after clearing the filters
      // so original results get re-populated
      filter()
    }    

    function onClearFilterButtonClick() {
      clearFilters()
      // when we clear the filters, we want screen-readers to announce 'Filters Cleared'
      // but we don't want that text to show on the screen or be held in the div  
      // otherwise it will continuously get announced when a user traverses the component
      // so this is an accessibility hack to fix that issue
      clearText.value = "Filters cleared"
      setTimeout(function () {
        clearText.value = ''
      }, 1000)
    }

</script>

<style scope>

button {
  width: 100%;
}
</style>